import React from "react";
import HeaderCustom from "../../components/header/HeaderCustom";
import { ButtonStyleVerde, DivBackgroundDasboard, TypographyStyleSecundary } from "../../styles/Styles";
import { Box } from '@mui/material';

function ErrorPage() {

    return (
        <DivBackgroundDasboard style={{ height: '100vh' }}>
            <HeaderCustom title={"No encontrado"}>
                <Box>
                    <TypographyStyleSecundary component="h4" variant="h4" align='center'>
                        No se encuentra la página
                    </TypographyStyleSecundary>


                    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <ButtonStyleVerde
                            variant="contained"
                            onClick={() => window.location.href = "/"}
                        >
                            Volver al inicio
                        </ButtonStyleVerde>
                    </Box>
                </Box>
            </HeaderCustom>
        </DivBackgroundDasboard>
    )
}

export default ErrorPage;